import React from 'react';
import styled, { css } from 'styled-components';

import { media } from '@/utils/mixin';
import { ContentContainer } from '@/modules/TheLineup/common.styles';
import { Breadcrumbs } from '@/components/Breadcrumbs';
import { useTheLineupData } from '@/modules/TheLineup/hooks';
import { TextContent } from '@/components/LandingWidgets';
import { colors } from '@/constants/theme';

function Header() {
  const {
    title,
    path,
    templateFields: { title: templateTitle, topText },
  } = useTheLineupData();

  return (
    <Component>
      <ContentContainer>
        <Breadcrumbs
          links={[
            { label: 'Главная', link: '/' },
            { label: title, link: path },
          ]}
        />

        <Title>{templateTitle}</Title>

        {topText && (
          <TextContentWrapper>
            <TextContent text={topText} />
          </TextContentWrapper>
        )}
      </ContentContainer>
    </Component>
  );
}

export default Header;

const Component = styled.section`
  padding: 30px 0;

  ${media.tablet(css`
    padding: 20px 0;
  `)}
`;

const Title = styled.h1`
  font-weight: 700;
  font-size: 35px;
  line-height: 45px;
  margin: 20px 0 0;
  color: ${colors.black};

  ${media.tablet(css`
    font-size: 22px;
    line-height: 29px;
  `)}
`;

const TextContentWrapper = styled.div`
  margin-top: 20px;
`;
